import AutoPopulateSurvey from './container'

export default AutoPopulateSurvey
